/**
 * Institutions Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";

// States
const state = {
    institutions: [],
    institution: {},
    selectedInstitution:{},
    userInstitutions:[],
};

// Getters
const getters = {

    institutions: state => {
        return state.institutions
    },

    selectedInstitution: state => {
        return state.selectedInstitution
    },

    institution: state => {
        return state.institution
    },

    userInstitutions :state => {
        return state.userInstitutions
    }
};

// Actions
const actions = {
    getInstitutions(context, payload) {
        function successCallback(response) {
            context.commit('getInstitutionsHandler', { institutions: response.data.etablissements });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Institution.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getInstitution(context, payload) {
        function successCallback(response) {
            context.commit('getInstitutionHandler', { institution: response.data.etablissement });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Institution.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getUserInstitutions(context, payload) {
        function successCallback(response) {
            context.commit('getUserInstitutionsHandler', { institutions: response.data.etablissements });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Institution.GetUserInstitution, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    setselectedInstitution(context, payload) {
            context.commit('setselectedInstitutionHandler', { selectedInstitution: payload.selectedInstitution});
    },

    createInstitution(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'institution', params: { institution: response.data.etablissement.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.Institution.Create, localToken, successCallback, errorCallback, payload.errorMessages);
        let url = AppConfig.apiUrl + apiModel.Institution.Create.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
    },

    createPatientInstitution(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.push({ name: 'patient', params: { patient: payload.args.patient } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.Institution.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    removePatientInstitution(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            context.commit('getPatientHandler', { patient: response.data.patient });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Patient.Institution.RemovePatient, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    removePraticienInstitution(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            context.commit('getPractitionerHandler', { practitioner: response.data.praticien });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Practitioner.Institution.RemovePraticien, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createPratitienInstitution(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'practitioner' });
            router.push({ name: 'practitioner', params: { practitioner: response.data.praticien.slug } });
            // router.push({ name: 'patient', params: { patient: payload.args.patient } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Practitioner.Institution.Add, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createControlDoctorInstitution(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'control-doctor' });

            router.push({ name: 'control-doctor', params: { doctor: response.data.medecin.slug } });
            // router.push({ name: 'patient', params: { patient: payload.args.patient } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ControlDoctor.Institution.Add, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    removeControlDoctorInstitution(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            context.commit('getControlDoctorHandler', { controlDoctor: response.data.medecin });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.ControlDoctor.Institution.RemoveControlDoctor, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateInstitution(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'institution' });

            router.push({ name: 'institution', params: { institution: response.data.etablissement.slug } });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        // makeApiRequest(payload.args, apiModel.Institution.Update, localToken, successCallback, errorCallback, payload.errorMessages);
        let url = AppConfig.apiUrl + apiModel.Institution.Create.url + '/' + payload.institution;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
    },

    deleteInstitution(context, payload) {
        function successCallback(response) {
            context.commit('deleteInstitutionHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Institution.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getInstitutionsHandler(state, { institutions }) {
        // Update institutions state
        state.institutions = institutions;
    },

    getInstitutionHandler(state, { institution }) {
        // Update institution state
        state.institution = institution;
    },

    getUserInstitutionsHandler(state, { institutions }) {
        // Update institution state
        state.userInstitutions = institutions;
    },

    setselectedInstitutionHandler(state, { selectedInstitution }) {
        // Update institution state
        state.selectedInstitution = selectedInstitution;
    },

    deleteInstitutionHandler(state, { index, successMessage }) {
        let i = state.institutions.findIndex(institution => institution.slug === index);

        if (~i) {
            state.institutions.splice(i, 1);

            router.push({ name: 'institutions' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}